import { render } from "./RoomsView.vue?vue&type=template&id=7c86b607"
import script from "./RoomsView.vue?vue&type=script&lang=js"
export * from "./RoomsView.vue?vue&type=script&lang=js"

import "./RoomsView.vue?vue&type=style&index=0&id=7c86b607&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__